import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "~/lib/trpc";
import { TrafficSourcesTable } from "~/routes/(app)/pages/$pageId/variants/$variantId/-components/traffic-sources-table";

export const Route = createFileRoute(
  "/(app)/pages/$pageId/variants/$variantId/targeting",
)({
  component: RouteComponent,
  loader: async ({ context: { queryClient }, params }) => {
    const data = await queryClient.ensureQueryData(
      trpc.variantTrafficSources.list.queryOptions({
        variantId: params.variantId,
      }),
    );

    return { data };
  },
});

function RouteComponent() {
  const { pageId, variantId } = Route.useParams();

  const { data } = useSuspenseQuery(
    trpc.variantTrafficSources.list.queryOptions({
      variantId,
    }),
  );

  return (
    <TrafficSourcesTable
      pageId={pageId}
      variantId={variantId}
      tableData={{
        rows: data.rules.map((rule) => ({
          id: rule.id,
          name: rule.name,
          type: rule.type,
          rule: rule.rule,
          testLink: rule.testLink,
        })),
        total: data.rules.length,
        page: 1,
        pageSize: data.rules.length,
      }}
    />
  );
}
